import FormTemplateService from 'src/modules/formTemplate/formTemplateService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/store';

const prefix = 'FORMTEMPLATE_VIEW';

const formTemplateViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: formTemplateViewActions.FIND_STARTED,
      });

      const record = await FormTemplateService.find(id);

      dispatch({
        type: formTemplateViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: formTemplateViewActions.FIND_ERROR,
      });

      getHistory().push('/form-template');
    }
  },
};

export default formTemplateViewActions;
